"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolbox_browser_fetch_1 = require("@zapier/toolbox-browser-fetch");
var utils_1 = require("../utils");
var CONTEXT_ENV = utils_1.isBrowser() ? 'client' : 'server';
var sendToBackend = function (config) { return function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, service, _b, baseUrl, schemaName, url, _c, identity_id, utm_campaign, utm_content, utm_medium, utm_source, page_path, screen_size, iframe_flag, popup_flag, user_agent, url_address, query_string, fully_qualified_domain_name, width, height, url;
    var _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = config.get(['service', 'baseUrl']), service = _a.service, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b;
                if (!event.name.startsWith('schema:')) return [3 /*break*/, 2];
                schemaName = event.name.split(':')[1];
                url = baseUrl + "/api/v4/tracking/event/";
                _c = event.context, identity_id = _c.identity_id, utm_campaign = _c.utm_campaign, utm_content = _c.utm_content, utm_medium = _c.utm_medium, utm_source = _c.utm_source;
                page_path = null;
                screen_size = null;
                iframe_flag = null;
                popup_flag = null;
                user_agent = null;
                url_address = null;
                query_string = null;
                fully_qualified_domain_name = null;
                if (utils_1.isBrowser()) {
                    // for browser based events, like PageViewEvent, we want to collect common Avro event
                    // properties here prior to making the v4 Events API request to emit the event
                    fully_qualified_domain_name = window.location.hostname;
                    url_address = window.location.href;
                    page_path = window.location.pathname;
                    query_string = window.location.search;
                    user_agent = window.navigator.userAgent;
                    width = window.innerWidth ||
                        document.documentElement.clientWidth ||
                        document.body.clientWidth;
                    height = window.innerHeight ||
                        document.documentElement.clientHeight ||
                        document.body.clientHeight;
                    screen_size = width + "x" + height;
                    iframe_flag = utils_1.isInIframe();
                    popup_flag = utils_1.isInPopup();
                }
                return [4 /*yield*/, toolbox_browser_fetch_1.postJson(url, {
                        subject: schemaName,
                        properties: __assign(__assign({}, event.data), { identity_id: identity_id,
                            fully_qualified_domain_name: fully_qualified_domain_name,
                            url_address: url_address,
                            query_string: query_string,
                            page_path: page_path,
                            screen_size: screen_size,
                            iframe_flag: iframe_flag,
                            popup_flag: popup_flag,
                            user_agent: user_agent,
                            utm_content: utm_content,
                            utm_medium: utm_medium,
                            utm_source: utm_source,
                            utm_campaign: utm_campaign, 
                            // When all Avro events have adopted the latest data governance guidance for events,
                            // we can remove this nested `context` as top level fields are now preferred.
                            context: (_d = {},
                                _d[(service || '') + "__" + CONTEXT_ENV] = event.context,
                                _d) }),
                    })];
            case 1:
                _f.sent();
                return [3 /*break*/, 4];
            case 2:
                url = baseUrl + "/api/v3/events";
                return [4 /*yield*/, toolbox_browser_fetch_1.postJson(url, {
                        message: event.name,
                        data: __assign(__assign(__assign({}, event._deprecatedBuildProprtiesInRoot()), event.data), { _data: event.data, _context: (_e = {},
                                _e[(service || '') + "__" + CONTEXT_ENV] = event.context,
                                _e) }),
                    })];
            case 3:
                _f.sent();
                _f.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports.default = sendToBackend;
